import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
function PrinterIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18 18V18C18.93 18 19.395 18 19.7765 17.8978C20.8117 17.6204 21.6204 16.8117 21.8978 15.7765C22 15.395 22 14.93 22 14V12.8C22 11.1198 22 10.2798 21.673 9.63803C21.3854 9.07354 20.9265 8.6146 20.362 8.32698C19.7202 8 18.8802 8 17.2 8H6.8C5.11984 8 4.27976 8 3.63803 8.32698C3.07354 8.6146 2.6146 9.07354 2.32698 9.63803C2 10.2798 2 11.1198 2 12.8V14C2 14.93 2 15.395 2.10222 15.7765C2.37962 16.8117 3.18827 17.6204 4.22354 17.8978C4.60504 18 5.07003 18 6 18V18M18 8V5.2C18 4.0799 18 3.51984 17.782 3.09202C17.5903 2.71569 17.2843 2.40973 16.908 2.21799C16.4802 2 15.9201 2 14.8 2H9.2C8.0799 2 7.51984 2 7.09202 2.21799C6.71569 2.40973 6.40973 2.71569 6.21799 3.09202C6 3.51984 6 4.07989 6 5.2V8M5 11H6M9 22H15C15.9319 22 16.3978 22 16.7654 21.8478C17.2554 21.6448 17.6448 21.2554 17.8478 20.7654C18 20.3978 18 19.9319 18 19V19C18 18.0681 18 17.6022 17.8478 17.2346C17.6448 16.7446 17.2554 16.3552 16.7654 16.1522C16.3978 16 15.9319 16 15 16H9C8.06812 16 7.60218 16 7.23463 16.1522C6.74458 16.3552 6.35523 16.7446 6.15224 17.2346C6 17.6022 6 18.0681 6 19V19C6 19.9319 6 20.3978 6.15224 20.7654C6.35523 21.2554 6.74458 21.6448 7.23463 21.8478C7.60218 22 8.06812 22 9 22Z"
          stroke="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
export default PrinterIcon;
